import React, {useState, useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import {Helmet} from "react-helmet"
import { Icon, Label, Popup, Modal, Button, Form, Input } from 'semantic-ui-react'
import {WindowURLAdmin,WindowLocationAdmin,WindowReload,ImagesURL} from '../../config/settings'
import Alertmessage from '../../config/alert'
import {loginvalidate} from './validations'
import Logo from '../../../assets/images/logo.png'
import Profile from '../../../assets/images/user.png'

export default function AdminLogin(props) {

  function AddCustomClassBody(){
    document.body.classList.add("login");
  }

  const [alert,setalert] = useState(true);
  const [Alertcontent,setAlertcontent] = useState({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
      //console.log(data.id);
    }
  }

  const [seen,setseen] = useState(false);
  const [state,setstate] = useState({
		email:'',
		password:''
	});

	function handleSubmitForm(values, props){
		//props.resetForm();
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','login');
		formData.append('info',JSON.stringify(values));
		axios.post('/admin/login/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Successfully login',html:"This won't take long, please wait..."}});
				setalert(true);
				setTimeout(function() {WindowLocationAdmin('/account/list');},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Login Error!',html:"Please enter your valid login credentials.",footer:'yes'}});
				setalert(true);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(false);
		});
	}


  function login(){
    setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
    let formData = new FormData();
    formData.append('type','IsLogin');
    axios.post('/admin/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj>0){WindowLocationAdmin('/account/list');return false;}
        setTimeout(function() {setalert(false);},2000);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }


  useEffect(()=>{
    AddCustomClassBody();
    login();
  },[]);

	return (
    <React.Fragment>
    <Helmet>
        <title>Gold Grup Limited- Admin Login</title>
    </Helmet>
    <Formik
        initialValues={state}
        validationSchema={loginvalidate}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
        return(
        <Form>
            {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

              <div className="login-wrapper">
                  <div className="login-container">
                      <div className="login-logo"><img src={ImagesURL('/logo.png')}/></div>
                      <div className="login-form">
                          <div className="login-form-header">
                            <div><img src={Profile}/></div>
                            <div>
                                <h3>Admin Login</h3>
                                <p>Enter your email and password</p>
                            </div>
                          </div>
                          <div className="login-form-body">
                              <Form.Group widths='equal'>
                                 <Field name="email">
                                 {({ field, form }) => (
                                     <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                       <label>Email</label>
                                       <Input fluid {...field} onChange={handleChange}/>
                                       { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i class="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                     </Form.Field>
                                 )}
                                 </Field>
                             </Form.Group>
                             <Form.Group widths='equal'>
                               <Field name="password">
                               {({ field, form }) => (
                                   <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                     <label>Password</label>
                                     <Input
                                       type={seen==true?'text':'password'}
                                       icon={<Icon name={seen==true?'eye':'eye slash'} link onClick={()=>setseen(seen==true?false:true)}/>}
                                       fluid {...field}
                                       onChange={handleChange}/>
                                     { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i class="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                   </Form.Field>
                               )}
                               </Field>
                             </Form.Group>
                          </div>
                          <div className="login-form-footer">
                              <div><Button fluid size='large' className='primary' icon='lock' content='LOGIN' onClick={handleSubmit}/></div>
                          </div>
                      </div>
                      <div className="login-copyright">© Copyright 2021. All rights reserved.</div>
                  </div>
              </div>


        </Form>
     )}}/>
     </React.Fragment>
	)
}
